import { computed, ref } from 'vue'

const _loaderState = ref(false)

export const isGlobalLoading = computed(() => {
    return _loaderState.value
})

export function startLoading () {
    setLoaderState(true)
}
export function stopLoading () {
    setLoaderState(false)
}
export function setLoaderState (state: boolean) {
    _loaderState.value = state
}
